import { LinkingOptions } from '@react-navigation/native';
import * as Linking from 'expo-linking';
import { RootStackParamList } from './types';

const prefix = Linking.createURL('/');

export const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [prefix, 'aia-member://', 'https://aia-member.app'],
  config: {
    screens: {
      Onboarding: 'onboarding',
      Main: {
        screens: {
          Home: 'home',
          Journeys: 'journeys',
          Inbox: 'inbox',
          Profile: 'profile',
        },
      },
      JourneyDetail: {
        path: 'journey/:journeyId',
        parse: {
          journeyId: (journeyId: string) => journeyId,
        },
      },
      DeepLink: {
        path: ':type/:title',
        parse: {
          type: (type: string) => type,
          title: (title: string) => title,
        },
      },
    },
  },
};
